module.exports = __webpack_public_path__ + "banner.9b40d991a454636548d22f207a2e8f26.jpg";